// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fG2H1","newExpiryDate":"styles_newExpiryDate__2lNE-","footer":"styles_footer__TSQqn"};